import * as React from "react"
import { Box } from "@chakra-ui/react"

import { ZonesTopbar } from "../components/ZonesTopbar"
import { ZonesMapContainer } from "../components/ZonesMap"
import { ZoneEntity, ZoneType } from "../lib/types/zone"
import { useDocumentTitle } from "../lib/hooks/useDocumentTitle"

export const Zones = () => {
  useDocumentTitle("Zones")

  const [type, setType] = React.useState<ZoneType>("dropzone")
  const [isCreating, setIsCreating] = React.useState<boolean>(false)
  const [editableZone, setEditableZone] = React.useState<ZoneEntity | null>(null)

  return (
    <Box>
      <ZonesTopbar {...{ type, setType }} />
      <ZonesMapContainer
        {...{
          type,
          isCreating,
          setIsCreating,
          editableZone,
          setEditableZone,
        }}
      />
    </Box>
  )
}
